import type { LessonRecurringTutor } from '../../interfaces'
import type { LessonRecurringStore } from './interfaces'

export const getters = {
  isLoading: (state: LessonRecurringStore): boolean => state.loading,
  getSlots: (state: LessonRecurringStore): LessonRecurringStore['slots'] => state.slots,
  getModal: (state: LessonRecurringStore): LessonRecurringStore['modal'] => state.modal,
  getToday: (state: LessonRecurringStore): LessonRecurringStore['today'] => state.today,
  getStartDate: (state: LessonRecurringStore): LessonRecurringStore['startDate'] => state.startDate,
  getDays: (state: LessonRecurringStore): LessonRecurringStore['days'] => state.days,
  getSelectedDay: (state: LessonRecurringStore): LessonRecurringStore['selectedDay'] => state.selectedDay,
  getFinishType: (state: LessonRecurringStore): LessonRecurringStore['finishType'] => state.finishType,
  getOccurrences: (state: LessonRecurringStore): LessonRecurringStore['occurrences'] => state.occurrences,
  getLessons: (state: LessonRecurringStore): LessonRecurringStore['lessons'] => state.lessons,
  getFinishDate: (state: LessonRecurringStore): LessonRecurringStore['finishDate'] => state.finishDate,
  getFilters: (state: LessonRecurringStore): LessonRecurringStore['filters'] => state.filters,
  getTutors: (state: LessonRecurringStore): LessonRecurringStore['tutors'] => state.tutors,
  isTutorsLoading: (state: LessonRecurringStore): boolean => state.tutorsLoading,
  getTutorId: (state: LessonRecurringStore): LessonRecurringStore['tutorId'] => state.tutorId,
  getSelectedTutor: (state: LessonRecurringStore): LessonRecurringTutor | null =>
    state.tutors.find(tutor => tutor.id === state.tutorId) ?? null,
  isSubmitting: (state: LessonRecurringStore): boolean => state.submitting,
}
